import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=6446dedc&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=6446dedc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446dedc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6446dedc')) {
      api.createRecord('6446dedc', component.options)
    } else {
      api.reload('6446dedc', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=6446dedc&scoped=true", function () {
      api.rerender('6446dedc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/Home.vue"
export default component.exports